import { render } from "./ProfileNotifications.view.vue?vue&type=template&id=25f8061a"
import script from "./ProfileNotifications.view.vue?vue&type=script&lang=js"
export * from "./ProfileNotifications.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__